export function timeFix() {
    const time = new Date()
    const hour = time.getHours()
    return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome() {
    const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
    const index = Math.floor(Math.random() * arr.length)
    return arr[index]
}





/**
 * 判断是否为数字
 * @param {String} char 需要判断字符
 */
export function isNum(num) {
    let reg = /[0-9]/
    if (!reg.test(num)) {
        return false
    }
    return true
}




/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
    const event = document.createEvent('HTMLEvents')
    event.initEvent('resize', true, true)
    event.eventType = 'message'
    window.dispatchEvent(event)
}

//权限限制
export function getOperations() {
    var router = window.location.href.substring(window.location.href.indexOf("#") + 1)
        // var router = this.$route.path
    var menuData = JSON.parse(localStorage.getItem("menuData"))
    let data = []
    menuData.map(item => {
        if (!item.children) {
            if (item.url == router) {
                data = item.operations
            }
        } else {
            item.children.map(i => {
                if (i.url == router) {
                    data = i.operations
                }
            })
        }
    })
    return data
}

export function judgePermission(e) {
    return getOperations().includes(e)
}

export function fancha(e) {
    var area = JSON.parse(sessionStorage.getItem("area"))
    var arr = []
    area.map((item, index) => {
        if (item.value == e) {
            arr = [index]
        } else {
            if (item.children) {
                item.children.map((i, j) => {
                    if (i.value == e) {
                        arr = [index, j]
                    } else {
                        if (i.children) {
                            i.children.map((m, n) => {
                                if (e == m.value) {
                                    arr = [index, j, n]
                                } else {
                                    if (m.children) {
                                        m.children.map((o, p) => {
                                            if (o.value == e) {
                                                arr = [index, j, n, p]
                                            } else {
                                                if (o.children) {
                                                    o.children.map((a, b) => {
                                                        if (a.value == e) {
                                                            arr = [index, j, n, p, b]
                                                        }
                                                    })
                                                }
                                            }
                                        })
                                    }
                                }
                            })
                        }
                    }
                })
            }
        }
    })
    return arr;
}

export function getDeviceNameByid(value, items) {
    for (let o of items || []) {
        if (o.value == value) return o
        const o_ = getDeviceNameByid(value, o.children)
        if (o_) return o_
    }
}

export function getLocalTime(e) {
    var dateee = new Date(e).toJSON();
    var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
    return date
}

//时间格式转换 西八区+8
export function getISOtime(e) {
    var time = new Date(e).getTime() + 8 * 60 * 60 * 1000
    var date = new Date(time)
    var result = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
    return new Date(result).toISOString()
}

// export function handleScrollHeader(callback) {
//     let timer = 0

//     let beforeScrollTop = window.pageYOffset
//     callback = callback || function () {
//     }
//     window.addEventListener(
//         'scroll',
//         event => {
//             clearTimeout(timer)
//             timer = setTimeout(() => {
//                 let direction = 'up'
//                 const afterScrollTop = window.pageYOffset
//                 const delta = afterScrollTop - beforeScrollTop
//                 if (delta === 0) {
//                     return false
//                 }
//                 direction = delta > 0 ? 'down' : 'up'
//                 callback(direction)
//                 beforeScrollTop = afterScrollTop
//             }, 50)
//         },
//         false
//     )
// }

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
    if (id === '') {
        return
    }
    setTimeout(() => {
        document.body.removeChild(document.getElementById(id))
    }, timeout)
}

/**
 * 获取到当前页面对应的菜单对象
 */
import { getItemFormLocalstorage } from "../../utils/package-localstorage";

export function getMyMenuObj(menuCode) {
    var menuData = getItemFormLocalstorage("menuData");
    var isReturn = null;
    menuData.map((item) => {

        //查找传入的menuCode
        if (menuCode) {
            if (item.menuCode == menuCode) {
                isReturn = item;
                // return item;
            } else if (item.children) {
                item.children.map((childrenItem) => {
                    if (childrenItem.code == menuCode) {
                        isReturn = childrenItem;
                        // return childrenItem;
                    } else if (childrenItem.children) {
                        childrenItem.children.map((childrenChildrenItem) => {
                            if (iUrl == childrenChildrenItem.url) {
                                isReturn = childrenChildrenItem;
                                // return childrenItem;
                            }
                        })
                    }
                })
            }
        } else {
            var curUrl = window.location.href;
            var iUrl = curUrl.substring(curUrl.indexOf('#') + 1);
            if (iUrl == item.url) {
                isReturn = item;
                // return item;
            } else if (item.children) {
                item.children.map((childrenItem) => {
                    if (iUrl == childrenItem.url) {
                        isReturn = childrenItem;
                        // return childrenItem;
                    } else if (childrenItem.children) {
                        childrenItem.children.map((childrenChildrenItem) => {
                            if (iUrl == childrenChildrenItem.url) {
                                isReturn = childrenChildrenItem;
                                // return childrenItem;
                            }
                        })
                    }
                })
            }
        }
    });
    return isReturn;
}

import { refreshToken ,ChangeLanguage} from "../api/api";
import { setItemToLocalstorage } from "../../utils/package-localstorage";
import { setCookie, getCookie } from "../../utils/package-cookies";

/**
 * 刷新token
 */
export function refreshMyToken(objThat) {
    refreshToken().then(
            (res) => {
                if (res.success === true) {
                    setItemToLocalstorage("userId", res.result.userId); //存储用户信息
                    setItemToLocalstorage("userName", res.result.userName);

                    var token = res.result.accessToken;
                    setCookie("auth", token, 20);
                    objThat.$store.commit("saveauth", token);

                    var curTime = new Date();
                    var expiredate = new Date(
                        curTime.setSeconds(
                            curTime.getSeconds() + res.result.expireInSeconds
                        )
                    );
                    objThat.$store.commit("saveTokenExpire", expiredate);

                    window.localStorage.refreshtime = expiredate;
                    window.localStorage.expires_in = res.result.expireInSeconds;
                } else {
                    // objThat.$message.error(res.error.message);
                    //console.log(res.error.message);
                }

            },
            (err) => {
                ////console.log(res.error.message);
                // objThat.$message.error(err.error.message);
            }
        )
        .catch((err) => {
            //console.log(res.error.message);
            // objThat.$message.error("刷新token失败");
            // console.log(err)
        });

}

//设置登录后的逻辑
export function setLoginLogic(objThat, res) {
    if (res.success === true) {
        setItemToLocalstorage("userId", res.result.userId); //存储用户信息
        setItemToLocalstorage("userName", res.result.userName);
        setItemToLocalstorage("roles", res.result.roles);
        var token = res.result.accessToken;
        setCookie("auth", token, 20);

        objThat.$store.commit("saveauth", token);
        var curTime = new Date();
        var expiredate = new Date(
            curTime.setSeconds(
                curTime.getSeconds() + res.result.expireInSeconds
            )
        );


        objThat.$store.commit("saveTokenExpire", expiredate);
        objThat.$store.dispatch('setLanguage', res.result.lang)
        objThat.$store.dispatch('applicationConfiguration',res.result.lang)
        window.localStorage.refreshtime = expiredate;
        window.localStorage.expires_in = res.result.expireInSeconds;
        var langStr = objThat.$route.query.state || objThat.query("state");
        if(langStr){
            objThat.$store.dispatch('setLanguage', res.result.lang)
            objThat.$store.dispatch('applicationConfiguration',res.result.lang)
        }

        //如果有?code,就切掉code跳转
        var myQueryStr = objThat.$route.query.code || objThat.query("code");
        if (myQueryStr) {
            //如果有#符号就到#符号，如果没有#符号，就直接就加上地址
            var uriredirect = window.location.href;

            if (!uriredirect.indexOf("?") && !uriredirect.indexOf("#")) {

            } else if (uriredirect.indexOf("?") < uriredirect.indexOf("#") || uriredirect.indexOf("#") < 0) { //#/login在?code后面 或没#
                uriredirect = uriredirect.substring(0, uriredirect.indexOf("?"));
            } else if (uriredirect.indexOf("#") > 0) {
                uriredirect = uriredirect.substring(0, uriredirect.indexOf("#"));
            }
            uriredirect = uriredirect + "#/pbreport";
            location.href = uriredirect;
            //objThat.$router.push("/pbreport");
        } else {
            objThat.$router.push("/");
        }

    } else {
        //如果有?code,就切掉code跳转
        // var myQueryStr = this.$route.query.code || this.query("code");
        // if (myQueryStr) {
        //     location.href = window.location.href.substring(0, window.location.href.indexOf("?"));
        // }
        objThat.$message.error(res.error.message);
    }
}
